export default __webpack_public_path__ + "static/media/butcheredmeat.2e4e7e28.png";